import { CSSProperties } from "react"
import { useSortable } from "@dnd-kit/sortable"
import { DraggableSyntheticListeners } from "@dnd-kit/core"

import { getTranslate } from "./helpers"

export type UseSortableRowOptions = {
  id: string
  disabled?: boolean
}

export type UseSortableRow = {
  style: CSSProperties
  setNodeRef: (node: HTMLElement | null) => void
  listeners: DraggableSyntheticListeners
  isDragging: boolean
}

export function useSortableRow(options: UseSortableRowOptions): UseSortableRow {
  const { id, disabled = false } = options
  const { listeners, setNodeRef, transform, transition, active, isDragging } =
    useSortable({
      id: id,
      disabled,
    })

  const isActive = active?.id === id
  const style = {
    transform: getTranslate(transform),
    transition: transition || undefined,
    opacity: isActive ? 0 : 1,
    userSelect: isActive ? "none" : undefined,
  } as CSSProperties

  return {
    style,
    setNodeRef,
    listeners,
    isDragging,
  }
}
